
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-buy/platinum-buyers",
      function () {
        return require("private-next-pages/what-we-buy/platinum-buyers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-buy/platinum-buyers"])
      });
    }
  